// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"984":"f58dea7e","3142":"62e3a4ce","3352":"f8ca88b4","3690":"e5ed626e","4924":"b1c5ae78","5006":"d8dfc671"}[chunkId] + ".js";
};